import { ZipCodeFilterState } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export type FilterZipRangeProps = {
  label: string
  active: ZipCodeFilterState
  onClose?: () => void
  isExclusive: boolean
  isHovered?: boolean
}

export function FilterChipZipRange({
  label,
  active,
  onClose,
  isExclusive,
  isHovered,
}: FilterZipRangeProps) {
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'
  const getFormattedValue = () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const zipcode = active?.[0]!
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const range = active?.[1]!
    return `${zipcode} (${range} mile${range > 1 ? 's' : ''})`
  }

  return (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${label}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{getFormattedValue()}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )
}
